import axios from "axios";
import { OKGPORTAL_URL } from "../model/constants";
import { PIN_REQUIRED_EVENT } from "../model/auth.events";

const $okgportal_api = axios.create({
  withCredentials: true,
  baseURL: OKGPORTAL_URL
})

$okgportal_api.interceptors.request.use((config) => {
  config.headers = config.headers || {};
  config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
  return config;
})

$okgportal_api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401 || (
      error.response?.status === 403 &&
      String(error.response?.data?.error_message || '').includes('PIN')
    )) {
      window.dispatchEvent(new Event(PIN_REQUIRED_EVENT));
    }
    return Promise.reject(error);
  }
)

export default $okgportal_api;
